/* Native Shopify forms handle cart and newsletter submissions, even without JavaScript. */
if (!customElements.get('raizde-home')) {
  customElements.define('raizde-home', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      const menu = this.querySelector('.rd-menu');
      const nav = this.querySelector('#navigation');
      const closeMenu = () => {
        if (!menu || !nav) return;
        menu.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-label', 'Open menu');
        menu.textContent = '☰';
        nav.classList.remove('rd-open');
      };
      menu?.addEventListener('click', () => {
        const expanded = menu.getAttribute('aria-expanded') === 'true';
        menu.setAttribute('aria-expanded', String(!expanded));
        menu.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
        menu.textContent = expanded ? '☰' : '×';
        nav?.classList.toggle('rd-open', !expanded);
      }, options);
      nav?.addEventListener('click', event => {
        if (event.target.closest('a')) closeMenu();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && nav?.classList.contains('rd-open')) {
          closeMenu();
          menu.focus();
        }
      }, options);
      const desktop = matchMedia('(min-width: 851px)');
      desktop.addEventListener('change', closeMenu, options);
      const track = this.querySelector('[data-rd-review-track]');
      const controls = this.querySelector('.rd-review-controls');
      if (track && controls) {
        const update = () => { controls.hidden = track.scrollWidth <= track.clientWidth + 1; };
        const scroll = direction => {
          const card = track.querySelector('article');
          if (!card) return;
          const end = track.scrollWidth - track.clientWidth;
          if (end < 1) return;
          let left = track.scrollLeft + direction * (card.getBoundingClientRect().width + 20);
          if (direction > 0 && track.scrollLeft >= end - 2) left = 0;
          else if (direction < 0 && track.scrollLeft <= 2) left = end;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.querySelector('[data-rd-reviews-prev]')?.addEventListener('click', () => scroll(-1), options);
        this.querySelector('[data-rd-reviews-next]')?.addEventListener('click', () => scroll(1), options);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
